import React, {useState} from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  FlatList,
} from 'react-native';
import {Color, globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import Width from '../../../assets/Width';
import EventChildComponent from './EventChildComponent';
import {globalImport} from '../../../common/globalImports';
import FastImage from '../../../common/FastImage';
import {down_arrow, up_arrow} from '../../../utils/images';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {
  globalConfigurableData,
  GlobalScreens,
} from '../../../utils/globalConstant';
import {getReturns, giveCorrectPrice} from '../../../utils/commonMethods';
import { Accordion } from "../../../components/core/Accordion";
const OrderBook = props => {
  const [showOrderbook, setOrderbook] = useState(false);
  const {onOrderBookClick} = props;
  const event = props?.event;

  let calls1 = props.eventDetails?.calls;

  if (!calls1) return null;

  var calls = calls1;
  var modififedCalls = [];
  var modifiedIndex = -1;

  calls.map((call, index) => {
    var callObj = {N: null, Y: null};

    if (call.callvalue === 'Y') {
      modifiedIndex = index;
      callObj.Y = call;
      modififedCalls.push(callObj);
    }
    if (call.callvalue === 'N') {
      if (modififedCalls[index - (modifiedIndex + 1)]) {
        modififedCalls[index - (modifiedIndex + 1)].N = call;
      } else {
        callObj.N = call;
        modififedCalls.push(callObj);
      }
    }
  });

  let item = 0;
  for (let i = 0; i < calls.length; i++) {
    let item1 = calls[i];
    if (item1.noofcontracts > item) {
      item = item1.noofcontracts;
    }
  }

  const calculateWidth = quantity => {
    return parseInt((((Width.width - 26) / 2) * quantity) / item);
  };

  let newYCP = 0,
    newNCP = 0;

  const renderProbeCard = ({item: call, index}) => {
    var callsN = call.N;
    var callsY = call.Y;
    if (callsN) {
      newYCP = event?.totalamount - callsN?.coins;
      newYCP = newYCP;
    }
    if (callsY) {
      newNCP = event?.totalamount - callsY?.coins;
      newNCP = newNCP;
    }

    return (
      <View style={styles.tableRow}>
        <TouchableOpacity
          activeOpacity={0.8}
          onPress={() =>
            callsN && callsN.callvalue !== 'Y' && onOrderBookClick(callsN)
          }
          style={styles.tableColumnBar}>
          {callsN ? (
            <Text style={styles.yesPrice}>
              {giveCorrectPrice({yPrice: newYCP})}{' '}
            </Text>
          ) : (
            <></>
          )}
          {callsN?.callvalue !== 'Y' && (
            <>
              <Text
                style={[
                  styles.yesQuantity,
                  {
                    flex: 1,
                    textAlign: 'right',
                    paddingRight: 4,
                  },
                ]}>
                {callsN?.noofcontracts
                  ? getReturns(callsN?.noofcontracts).toFixed(2)
                  : callsN?.noofcontracts}
              </Text>

              <View
                style={[
                  {
                    backgroundColor: GlobalScreens.Event.yesBtnBlock,
                    width: calculateWidth(callsN?.noofcontracts || 0),
                    height: 34,

                    right: 0,
                    position: 'absolute',
                  },
                  globalImport.isWeb ? {top: 0} : null,
                ]}
              />
            </>
          )}
        </TouchableOpacity>
        <View
          style={{
            height: '100%',
            width: 1,
            backgroundColor: GlobalScreens.Event.borderColor,
          }}
        />
        <TouchableOpacity
          activeOpacity={0.8}
          onPress={() =>
            callsY && callsY?.callvalue !== 'N' && onOrderBookClick(callsY)
          }
          style={styles.tableColumnBar}>
          {callsY?.callvalue !== 'N' && (
            <>
              <View
                style={[
                  {
                    backgroundColor: GlobalScreens.Event.noBtnBlock,
                    width: calculateWidth(callsY?.noofcontracts || 0),
                    height: 34,
                    //borderWidth: 1,

                    position: 'absolute',
                  },
                  globalImport.isWeb ? {top: 0} : null,
                ]}
              />
              <Text style={[styles.yesQuantity, {paddingLeft: 6, flex: 1}]}>
                {callsY?.noofcontracts
                  ? getReturns(callsY?.noofcontracts).toFixed(2)
                  : callsY?.noofcontracts}
              </Text>
            </>
          )}
          {callsY ? (
            <Text
              style={[
                styles.noPrice,
                {
                  alignItems: 'flex-end',
                  justifyContent: 'flex-end',
                  textAlign: 'right',
                  flex: 1,
                },
              ]}>
              {giveCorrectPrice({nPrice: newNCP})}
            </Text>
          ) : null}
        </TouchableOpacity>
      </View>
    );
  };

  const headerCompoenent = () => {
    return (
      <View style={styles.tableHeader}>
        <FormTextLabel labelStyles={styles.yesHeaderText} label={'Buy Yes'} />
        <FormTextLabel
          labelStyles={styles.quantityHeaderText}
          label={'Quantity'}
        />
        <FormTextLabel labelStyles={styles.noHeaderText} label={'Buy No'} />
      </View>
    );
  };

  return (
    <View
      style={{
        borderWidth: 0.75,
        borderColor: GlobalScreens.Event.borderColor,
        borderRadius: 3,
        marginBottom: 15,
      }}>
      {modififedCalls && modififedCalls.length > 0 ? (
        <>
          <FlatList
            nestedScrollEnabled={true}
            contentContainerStyle={{flexGrow: 0}}
            ListHeaderComponent={headerCompoenent}
            scrollEnabled
            data={showOrderbook ? modififedCalls : modififedCalls.slice(0, 5)}
            renderItem={renderProbeCard}
            keyExtractor={(item, index) => index}
            showsVerticalScrollIndicator={false}
            initialNumToRender={10}
          />
          {modififedCalls.length > 5 && (
            <Accordion
              defaultValue={showOrderbook}
              onValueChange={setOrderbook}
              label={showOrderbook ? 'Collapse' : 'View in depth'}
              style={{
                borderTopWidth: 0.75,
                borderTopColor: GlobalScreens.Event.borderColor,
                borderRadius: 0,
              }}
              triggerStyle={{
                height: 35,
                paddingHorizontal: 16,
                paddingVertical: 0,
                justifyContent: 'center',
              }}
              contentStyle={{
                padding: 0,
              }}
              iconColor={globalConfigurableData.primaryTextColor1}
              showIcon={true}
            />
          )}
        </>
      ) : (
        <View style={{padding: 12}}>
          <FormTextLabel
            labelStyles={{color: globalConfigurableData.tertiaryTextColor1}}
            label={
              'There are no open orders right now to take filled positions.'
            }
          />
        </View>
      )}
    </View>
  );
};

export default OrderBook;

const styles = StyleSheet.create({
  tableHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 35,
    alignItems: 'center',
    paddingHorizontal: 8,
  },
  tableRow: {
    flexDirection: 'row',
    borderColor: GlobalScreens.Event.borderColor,
    borderTopWidth: 0.5,
    //paddingVertical: 10,
    paddingHorizontal: 8,
  },
  yesPrice: {
    ...globalFontStyle.appFontSubTextBold,
    color: GlobalScreens.Event.yesBtnTxt,
    zIndex: 1,
  },
  noPrice: {
    ...globalFontStyle.appFontSubTextBold,
    color: GlobalScreens.Event.noBtnTxt,
    zIndex: 1,
  },
  yesQuantity: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.secondaryTextColor1,
    lineHeight: 13.7,
    zIndex: 1,
  },
  yesHeaderText: {
    ...globalFontStyle.appFontSubTextBold,
    color: GlobalScreens.Event.yesBtnTxt,
  },
  noHeaderText: {
    ...globalFontStyle.appFontSubTextBold,
    color: GlobalScreens.Event.noBtnTxt,
  },
  quantityHeaderText: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.tertiaryTextColor1,
  },
  tableColumnBar: {
    width: '50%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 35,
    alignItems: 'center',
  },
});
